import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import convertFrancFeeToPercent from 'utils/fee/convertFrancFeeToPercent';

import { IFeesInfoProps } from './FeesInfo.types';

import './FeesInfo.scss';

const { Text } = Typography;

const FeesInfo = ({ poolFee, totalFee }: IFeesInfoProps) => {
  const { t } = useTranslation();

  return (
    <div className="np-fees-info">
      <Text>{t('form.label.poolFee')}:</Text>
      <Text strong>{convertFrancFeeToPercent(poolFee, { symbol: '%' })}</Text>

      <Text>{t('form.label.totalComission')}:</Text>
      <Text strong>{convertFrancFeeToPercent(totalFee, { symbol: '%' })}</Text>
    </div>
  );
};

export default FeesInfo;
